import { Table } from "antd";
import TableFilter from "./TableFilter";
import { useState } from "react";
import { useEffect } from "react";
import EditPartnerForm from "./editPartner";
import PaymentRequestPopup from "./paymentRequestPopup";
import dayjs from "dayjs";
import config from "../../../config";
import ValidatePartnerRequestPopup from "./validatePartnerRequestPopup";

const base_url = config.base_url;
function PaymentsAndRequests({
  openAddNewPartner,
  setOpenAddNewPartner,
  closeAddPartnerModal,
}) {
  const [tableLoading, setTableLoading] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [openPaymentRequest, setOpenPaymentRequest] = useState(false);
  const [paymentRequestData, setPaymentRequestData] = useState({});
  const [openValidatePartner, setOpenValidatePartner] = useState(false);
  const [data, setData] = useState([]);
  const [currencyData, setCurrencyData] = useState();
  const [userId, setUserId] = useState(null);
  const [openEditPartnerModal, setOpenEditPartnerModal] = useState(false);
  const [popup, setPopup] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const onOkEditPartnerModal = () => {
    setOpenEditPartnerModal(false);
  };
  const onCancelEditPartnerModal = () => {
    setOpenEditPartnerModal(false);
  };
  const columns = [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    {
      key: "1",
      title: "Partner Name",
      dataIndex: "partner_name",
      sorter: (a, b) => {
        return a.partner_name.localeCompare(b.partner_name);
      },

      render: (text, record, index) => {
        return (
          <p
            data-openpopup={"no"}
            onClick={(e) => {
              setUserId(record.partner_id);
              setOpenEditPartnerModal(true);
            }}
          >
            <span data-openpopup={"no"}>{record.index}.&nbsp;&nbsp;&nbsp;</span>
            <span
              data-openpopup={"no"}
              style={{
                textDecoration: "underline",
                color: "rgb(0, 145, 234)",
                maxWidth: "170px",
                display: "inline-block",
              }}
            >
              {text}
            </span>
          </p>
        );
      },
    },
    {
      key: "2",
      title: "Partner Type",
      dataIndex: "partner_type",
      sorter: (a, b) => {
        return a.partner_type.localeCompare(b.partner_type);
      },
      render: (text, record, index) => {
        if (!text) return <span>{text}</span>;
        if (text === "agency") {
          return <span> Legal Advisor</span>;
        }
        return <span> {text.charAt(0).toUpperCase() + text.slice(1)}</span>;
      },
    },

    {
      key: "3",
      title: "User ID",
      dataIndex: "partner_id",
      sorter: (a, b) => {
        return a.partner_id.localeCompare(b.partner_id);
      },
    },
    {
      key: "4",
      title: "Request Date",
      dataIndex: "date",
      sorter: (a, b) => {
        return a.date.localeCompare(b.date);
      },
    },
    {
      key: "5",
      title: "Email Address",
      dataIndex: "partner_email",
      sorter: (a, b) => {
        return a.partner_email.localeCompare(b.partner_email);
      },
    },
    {
      key: "6",
      title: "Request Type",
      dataIndex: "request_type",
      sorter: (a, b) => {
        return a.request_type.localeCompare(b.request_type);
      },
      //
      filters: [
        { text: "Payment", value: "payment" },
        { text: "Validation", value: "validation" },
      ],
      onFilter: (record, value) => {
        return value.request_type === record;
      },
      render: (text, record, index) => {
        let style;
        if (text === "validation") {
          style = { color: "#4100AC" };
          return <p style={style}>{"Partner's Validation"}</p>;
        } else if (text === "payment") {
          style = { color: "#419F23" };
          return <p style={style}>{"Payment request"}</p>;
        } else style = { color: "black" };
        return <p style={style}>{text}</p>;
      },
    },
    {
      key: "7",
      title: "Amount",
      dataIndex: "quantity",
      sorter: (a, b) => {
        return a.amount - b.amount;
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "center" }}>-</p>;
        else return <p>${text}</p>;
      },
    },
    {
      key: "8",
      title: "Payment Method",
      dataIndex: "payment_method",
      sorter: (a, b) => {
        if (a.payment_method === undefined || b.payment_method === undefined)
          return;
        return a.payment_method.localeCompare(b.payment_method);
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "center" }}>-</p>;
        else if (text === "paypal") return <p>Paypal</p>;
        else if (text === "bank") return <p>Bank Transfer</p>;
        else return <p>{text}</p>;
      },
    },
    {
      key: "9",
      title: "Request Status",
      dataIndex: "status",
      disableSortBy: true,
      sorter: (a, b) => {
        return a.status.localeCompare(b.status);
      },
      render: (text, record, index) => {
        let style;

        if (text === "rejected") {
          style = { color: "#B20606" };
          return <p style={style}>Missing/Incorrect Information</p>;
        } else if (text === "completed") {
          style = { color: "#419F23" };
          return <p style={style}>Completed</p>;
        } else if (text === "pending") {
          style = { color: "#000000" };
          return <p style={style}>Waiting for Approval</p>;
        } else style = { color: "black" };
        return <p style={style}>{text}</p>;
      },
    },
    {
      key: "10",
      title: "Completion Date",
      dataIndex: "completed_date",
      sorter: (a, b) => {
        return a.completion_date.localeCompare(b.completion_date);
      },
      //   render: (text, record, index) => {
      //     return <p>{text}</p>;
      //   },
    },
    {
      key: "11",
      title: "Updated by",
      dataIndex: "updated_by_id",
      sorter: (a, b) => {
        return a.updated_by_id.localeCompare(b.updated_by_id);
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "center" }}>-</p>;
        else return <p>{text}</p>;
      },
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
  ];
  const globalSearchFunction = (value) => {
    setGlobalSearch(value);
  };
  useEffect(() => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(globalSearch.toLowerCase())
      )
    );

    setFilteredData(filterTable);
  }, [globalSearch]);
  const voidFunction = (data) => {};

  const onOkValidatePartner = () => {
    setOpenValidatePartner(false);
  };
  const onCancelValidatePartner = () => {
    setOpenValidatePartner(false);
  };
  const onOkPaymentRequestModal = () => {
    setOpenPaymentRequest(false);
  };
  const onCancelPaymentRequestModal = () => {
    setOpenPaymentRequest(false);
  };
  useEffect(() => {
    setTableLoading(true);
    fetch(base_url + "admin/partners/validations/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: ``,
    })
      .then((res) => res.json())
      .then((res) => {
        setCurrencyData(res?.currencyData);
        const content = res.data
          .sort((a, b) => {
            return b.date - a.date;
          })
          .map((data, i) => {
            return {
              index: res.data.length - i,
              ...data,
              date: dayjs(data.date).format("YYYY-MM-DD"),
              completed_date: dayjs(data.completed_date).format("YYYY-MM-DD"),
            };
          });
        setData(content);
        setFilteredData(content);
        setTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <>
      <PaymentRequestPopup
        currencyData={currencyData}
        open={openPaymentRequest}
        onOk={onOkPaymentRequestModal}
        onCancel={onCancelPaymentRequestModal}
        data={paymentRequestData}
        setData={setData}
        setFilteredData={setFilteredData}
      />
      <ValidatePartnerRequestPopup
        open={openValidatePartner}
        onCancel={onCancelValidatePartner}
        onOk={onOkValidatePartner}
        userId={userId}
        popup={popup}
        data={paymentRequestData}
        setData={setData}
        setFilteredData={setFilteredData}
      />
      <TableFilter component={2} globalSearch={globalSearchFunction} />
      <Table
        loading={tableLoading}
        pagination={{
          className: "partnerDataPagination",
          locale: { items_per_page: "" },
          pageSize: pageSize,
          current: page,
          showSizeChanger: true,
          total: data.length,
          onChange: (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          },
          showTotal: (total, range) => {
            return `Page ${page} of ${Math.ceil(total / pageSize)}`;
          },
          itemRender: (page, type, originalElement) => {
            if (type === "next") return <span>Next</span>;
            if (type === "prev") return <span>Previous</span>;
            if (type === "page") return null;
            return originalElement;
          },
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: (e) => {
              if (e.target.dataset.openpopup === "no") return;
              if (record.request_type === "payment") {
                setOpenPaymentRequest(true);
                setPaymentRequestData(record);
                setUserId(record.partner_id);
                setPopup("payment");
              }
              if (record.request_type === "validation") {
                setOpenValidatePartner(true);
                setPaymentRequestData(record);
                setUserId(record.partner_id);
                setPopup("validation");
              }
            },
          };
        }}
        rowClassName="td"
        columns={columns}
        dataSource={filteredData}
      ></Table>
      <EditPartnerForm
        onOk={closeAddPartnerModal}
        onCancel={closeAddPartnerModal}
        open={openAddNewPartner}
        component={"addPartner"}
        setData={voidFunction}
        setFilteredData={voidFunction}
      />
      <EditPartnerForm
        userId={userId}
        onOk={onOkEditPartnerModal}
        onCancel={onCancelEditPartnerModal}
        open={openEditPartnerModal}
        setData={voidFunction}
        setFilteredData={voidFunction}
        component={"edit"}
      />
    </>
  );
}

export default PaymentsAndRequests;
